/* global Config */
// Vendor Libs
import isEmpty from 'lodash.isempty';
import omitBy from 'lodash.omitby';
import querystring from 'querystring';
import cookie from 'react-cookies'; // Core Libs

import { serviceCaller } from './service-caller';

var omitQueryParams = function omitQueryParams(query) {
  return omitBy(query, function (val, key) {
    return val === undefined || val === null || key === 'timeout';
  });
};

var parseQuery = function parseQuery(query) {
  return JSON.stringify(omitQueryParams(query));
};

export var actionsServiceCaller = function actionsServiceCaller(actionParams, queryParams, customPath) {
  if (queryParams === void 0) {
    queryParams = {};
  }

  var cancelToken = actionParams.cancelToken,
      handleFetched = actionParams.handleFetched,
      handleError = actionParams.handleError,
      serviceConfig = actionParams.serviceConfig;
  var baseUrl = serviceConfig.baseUrl,
      contentType = serviceConfig.contentType,
      method = serviceConfig.method,
      path = serviceConfig.path,
      payloadType = serviceConfig.payloadType,
      responseType = serviceConfig.responseType,
      timeout = serviceConfig.timeout;
  var serviceParams = {
    handleFetched: handleFetched,
    handleError: handleError
  };
  var ajaxParams = {
    baseURL: baseUrl,
    cancelToken: cancelToken,
    contentType: contentType,
    headers: {},
    method: method,
    paramsSerializer: querystring.stringify,
    responseType: responseType,
    timeout: queryParams.timeout || timeout,
    url: customPath ? String(customPath).startsWith('/') ? customPath : path + "/" + customPath : path
  };

  var setCsrfTokenHeader = function setCsrfTokenHeader() {
    var csrfToken = cookie.load(Config.base.csrfTokenCookieName);

    if (csrfToken) {
      ajaxParams.headers[Config.base.csrfTokenHeaderName] = csrfToken;
    }
  };

  setCsrfTokenHeader();

  if (!isEmpty(queryParams)) {
    if (['POST', 'PUT', 'PATCH'].includes(method) && payloadType !== 'params') {
      ajaxParams.headers['Content-Type'] = contentType || 'application/json';
      ajaxParams.data = parseQuery(queryParams);
    } else {
      ajaxParams.params = omitQueryParams(queryParams);
    }
  }

  return serviceCaller(serviceParams, ajaxParams);
};